export const SENDGRID_SUBJECT_MAX = 255; // SendGrid allows up to 255 characters for subject
// Reserve a safety margin for merge tag expansion and prefixes (e.g., Re:, Fwd:)
export const EMAIL_SUBJECT_MAX_SAFE = SENDGRID_SUBJECT_MAX - 20;
//# sourceMappingURL=email.js.map